import React from 'react'

const getViewBox = name => {
  switch (name) {
    case 'triangle':
      return '0 0 55 55'
    case 'arrow':
      return '0 0 100 15'
    case 'star':
      return '0 0 89 85'
    case 'rhombus':
      return '0 0 80 80'
    default:
      return '0 0 32 32'
  }
}

const getPath = (name, props) => {
  switch (name) {
    case 'triangle':
      return <path d="M27.5 0L55 55H0z" />
    case 'arrow':
      return <path d="M0.792893 6.79289C0.402367 7.18341 0.402367 7.81657 0.792892 8.2071L7.15685 14.5711C7.54738 14.9616 8.18054 14.9616 8.57107 14.5711C8.96159 14.1805 8.96159 13.5474 8.57107 13.1568L2.91422 7.49999L8.57107 1.84314C8.96159 1.45261 8.96159 0.819449 8.57107 0.428925C8.18054 0.0384003 7.54738 0.0384002 7.15685 0.428925L0.792893 6.79289ZM94.5 6.5L1.5 6.49999L1.5 8.49999L94.5 8.5L94.5 6.5Z" />
    case 'star':
      return <path d="M44.5 0L54.9399 32.1307H88.7241L61.3921 51.9886L71.832 84.1193L44.5 64.2614L17.168 84.1193L27.6079 51.9886L0.275871 32.1307H34.0601L44.5 0Z" />
    case 'rhombus':
      return <path d="M40.04-.01l39.957 39.97L39.96 80.008 0 40.04z" />
    default:
      return <path />
  }
}

const ShapeElement = ({ item }) => {
  const { elementType, styles } = item.content
  return (
    <svg
      width="100%"
      height="100%"
      style={styles}
      fill="#bebebe"
      xmlns="http://www.w3.org/2000/svg"
      viewBox={getViewBox(elementType)}
    >
      {getPath(elementType)}
    </svg>
  )
}

export { ShapeElement, getPath }



// WEBPACK FOOTER //
// ./src/components/commons/editor/ShapeElement.js